import { FeaturePatternTrussContainer, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { FeatureAreaSchema } from './FeatureAreaSchema';

export const FeaturePatternContainerSchema = new ModelSchema<FeaturePatternTrussContainer>('featurePatternContainer', {
  category: ModelCategory.IntermediateModel,

  pluralName: 'Feature Pattern Containers',
  displayName: (item) => `Container ${item.name}`,

  properties: {},
  children: {
    featureAreas: FeatureAreaSchema,
  },
});
